import { useSyncExternalStore } from "react";

let viewed: string | null = null;
const listeners = new Set<() => void>();

export function showViewedPage(label: string | null): void {
  if (label === viewed) return;
  viewed = label;
  for (const listener of listeners) listener();
}

export function useViewedPage(): string | null {
  return useSyncExternalStore(subscribe, () => viewed);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
